module.exports = __webpack_public_path__ + "img/El-Cid-promo.8e4b5ed8.png";